module.exports = __webpack_public_path__ + "img/googlereviewsp1.89b59b0c.png";